import { render, staticRenderFns } from "./BowlerHistory.vue?vue&type=template&id=e6db87d2&scoped=true"
import script from "./BowlerHistory.vue?vue&type=script&lang=js"
export * from "./BowlerHistory.vue?vue&type=script&lang=js"
import style0 from "./BowlerHistory.vue?vue&type=style&index=0&id=e6db87d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6db87d2",
  null
  
)

export default component.exports